const Terms = () => import('@/modules/statics/views/Terms')

export default [
  {
    path: '/terms',
    name: 'statics.terms',
    component: Terms
  }
]
